import * as TK from 'components/auth/ForgotPasswordDialog/translations/constants';
import { Translations } from 'translations/types';

export const forgotPasswordDialogEnUsLocale: Translations = {
  [TK.FORGOT_PASSWORD_DIALOG_TITLE]: 'Reset password email was sent to',
  [TK.FORGOT_PASSWORD_DIALOG_BUTTON_TEXT]: 'Ok',
  [TK.FORGOT_PASSWORD_DIALOG_ICON_ALT]: 'Done icon',
};
